import React from "react";
import SocialLinks from "../constants/socialLinks";
import { StaticImage } from "gatsby-plugin-image";
import SumeshMajhiResume from "../files/SumeshMajhiResume.pdf";

const Header = () => {
  return (
    <header className="hero">
      <div className={`section-center hero-center`}>
        <article className="hero-info">
          <div className="underline"></div>
          <h1>i'm sumesh</h1>
          <h4>a software engineer and technical writer.</h4>

          <a href={SumeshMajhiResume} download className="btn hero-btn">
            Download Resume
          </a>
          <SocialLinks styleClass={`social-icons hero-icons`} />
        </article>
        <article>
          <StaticImage
            src="../images/hero.png"
            alt="hero"
            className="hero-photo"
            placeholder="tracedSVG"
          />
        </article>
      </div>
    </header>
  );
};

export default Header;
